import { Popover, VStack, HStack, Text, Checkbox, CheckboxGroup } from '@chakra-ui/react';
import { FilterPopoverButton, FilterPopoverContent } from './FilterPopover';
import { ICourse } from '@/shared/ICourse';
import { PLATFORM_VERSION } from '@/shared/constants';

export const CheckboxFilterVersion = (props: {
  allCourses: ICourse[];
  value: string[] | undefined;
  onSetFilter: (value: string[] | undefined) => void;
}) => {

  const getLabel = (version: string) => {
    switch (version) {
      case PLATFORM_VERSION.V1:
        return 'V1';
      case PLATFORM_VERSION.V2:
        return 'V2';
      default:
        return version;
    }
  }

  // Collect all existing platform versions from courses
  const versionCounts = new Map<string, number>();
  
  props.allCourses?.forEach(course => {
    // Missing value should be considered as V1
    const version = course.coursePlatformVersion || PLATFORM_VERSION.V1;
    versionCounts.set(version, (versionCounts.get(version) || 0) + 1);
  });

  const options = Array.from(versionCounts.entries()).map(([version, count]) => ({
    label: getLabel(version),
    value: version,
    count
  })).sort((a, b) => {
    // Sort versions: V2, V1 (newest first, then V1 as fallback)
    const versionOrder = [
      PLATFORM_VERSION.V2,
      PLATFORM_VERSION.V1
    ];
    
    const indexA = versionOrder.indexOf(a.value as PLATFORM_VERSION);
    const indexB = versionOrder.indexOf(b.value as PLATFORM_VERSION);
    
    // If not in predefined order, sort alphabetically
    if (indexA === -1 && indexB === -1) {
      return a.value.localeCompare(b.value);
    }
    if (indexA === -1) return 1; // Unknown versions go to end
    if (indexB === -1) return -1;
    
    return indexA - indexB;
  });

  const handleSelectionChange = (selectedValues: string[]) => {
    props.onSetFilter(selectedValues.length > 0 ? selectedValues : undefined);
  };

  const hasSelection = (props.value?.length || 0) > 0;

  return (
    <Popover isLazy placement="bottom-start">
      <FilterPopoverButton label="Version" selected={hasSelection} />
      <FilterPopoverContent>
        <CheckboxGroup value={props.value || []} onChange={handleSelectionChange}>
            <VStack spacing="2" align="stretch">
              {options.map((option) => (
                <Checkbox key={option.value} value={option.value} colorScheme="brand">
                  <HStack spacing="2" align="center">
                    <Text fontSize="sm" fontWeight="medium">{option.label}</Text>
                    <Text fontSize="sm" color="gray.500">
                      ({option.count})
                    </Text>
                  </HStack>
                </Checkbox>
              ))}
            </VStack>
          </CheckboxGroup>
        </FilterPopoverContent>
    </Popover>
  );
};
